import React, { useState } from 'react';
import AixueFooter from '@/components/AixueFooter/index';
import styles from './index.module.scss';
import downloadArrowUp from '@/assets/download/download-arrow-up.png';
import downloadArrowDown from '@/assets/download/download-arrow-down.png';
import downloadQuestion1 from '@/assets/download/download-question1.png';
import downloadQuestion2 from '@/assets/download/download-question2.png';
import Screen1 from './Screen1';
import Screen2 from './Screen2';

/** 常见问题项：answer 支持用 <br> 或  换行，answerStyle 控制文字颜色等；answerRedSuffix 为需红色展示的结尾段落 */
interface FaqItem {
  question: string;
  answer?: string;
  answerStyle?: React.CSSProperties;
  answerRedSuffix?: string;
  image?: string;
}

const FAQ_LIST: FaqItem[] = [
  {
    question: 'Mac电脑（苹果电脑）如何查看操作系统版本不低于macOS 12？',
    image: downloadQuestion1,
  },
  {
    question: 'Windows电脑如何查看操作系统是32位还是64位？',
    answer: `（1）按 Win+I 打开设置；
      （2）依次进入 系统 → 系统信息；
      （3）在 “设备规格” 区域，找到系统类型，显示 “64 位操作系统，基于 x64 的处理器”（64 位）或 “32 位操作系统，基于 x86 的处理器”（32 位）。`,
    image: downloadQuestion2,
  },
  {
    question: '移动端APP的支持情况？',
    answer: `苹果系统：AppStore（iPad/iphone）
移动端安卓APP支持范围：腾讯应用宝、华为、小米、华为、荣耀、OPPO、VIVO、步步高学习机、好未来学习机、希沃学习机、科大讯飞学习机`,
    answerRedSuffix: '不支持的设备：作业帮学习机、猿辅导学习机、优学派学习机',
  },
  {
    question: '网络差如何进行优化？',
    answer: `1. 网络连接优化：优先连 5G Wi-Fi（避开 2.4G 频段拥堵），路由器放房间中心、远离墙体 / 家电，手机 / 电脑靠近路由器；Wi-Fi 卡顿可切换手机流量测试，排除路由器故障。
2. 设备后台清理：关闭设备后台下载、云同步、自动更新（尤其是系统 / 大文件更新），暂停其他设备的视频、游戏等高带宽占用行为。
3. 路由器基础调试：重启路由器（拔掉电源 30 秒再插上），定期更新路由器固件；若支持 QoS 功能，将视频 APP 设为带宽优先级。
4. 网络环境排查：避开高峰时段（晚 7-11 点）观看其他视频，避免宽带占用；手机可切换飞行模式重连网络（使用流量或者WiFi），电脑重置网络设置（Win：cmd 输入 netsh winsock reset）。`,
  },
];

/** 将 answer 中的 <br> /  转为换行符，用 pre-line 换行，不单独渲染 br 元素 */
function renderAnswerText(text: string) {
  const normalized = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
  const withNewlines = normalized.replace(/<br\s*\/?>|<\/br>/gi, '\n');
  return <span style={{ whiteSpace: 'pre-line' }}>{withNewlines}</span>;
}

export default function AixueDownload() {
  const [expandedSet, setExpandedSet] = useState<Set<number>>(new Set([]));

  const toggleFaq = (index: number) => {
    setExpandedSet((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  return (
    <div className={`${styles.container}`}>
      <Screen1 />

      <Screen2 />

      <section className={styles['download-section-3']}>
        <div className={styles['section3-wrap']}>
          <h2 className={styles['section3-title']}>常见问题</h2>
          <ul className={styles['section3-faq-list']}>
            {FAQ_LIST.map((item, index) => (
              <li
                key={index}
                className={`${styles['section3-faq-item']} ${expandedSet.has(index) ? styles['section3-faq-item-expanded'] : ''}`}
              >
                <button
                  type="button"
                  className={styles['section3-faq-head']}
                  onClick={() => toggleFaq(index)}
                  aria-expanded={expandedSet.has(index)}
                >
                  <span className={styles['section3-faq-num']}>{index + 1}.</span>
                  <span className={styles['section3-faq-question']}>{item.question}</span>
                  <span className={styles['section3-faq-icon']} aria-hidden>
                    <img className={styles['section3-faq-icon-up']} src={downloadArrowUp} alt="" />
                    <img
                      className={styles['section3-faq-icon-down']}
                      src={downloadArrowDown}
                      alt=""
                    />
                  </span>
                </button>

                <div
                  className={styles['section3-faq-answer-wrap']}
                  data-expanded={expandedSet.has(index)}
                >
                  <div className={styles['section3-faq-answer']}>
                    <div className={styles['section3-faq-answer-inner']} style={item.answerStyle}>
                      {(item.answer != null && item.answer !== '') ||
                      item.answerRedSuffix != null ? (
                        <div className={styles['section3-faq-answer-txt-wrap']}>
                          <div>解答: </div>
                          <div style={item.answerStyle}>
                            {item.answer != null &&
                              item.answer !== '' &&
                              renderAnswerText(item.answer)}
                            {item.answerRedSuffix != null && item.answerRedSuffix !== '' && (
                              <>
                                {item.answer != null && item.answer !== '' && <br />}
                                <span
                                  style={{ color: 'red', display: 'block', lineHeight: 'inherit' }}
                                >
                                  {item.answerRedSuffix}
                                </span>
                              </>
                            )}
                          </div>
                        </div>
                      ) : null}
                      {item.image && (
                        <div className={styles['section3-faq-answer-img-wrap']}>
                          <img
                            src={item.image}
                            alt=""
                            className={styles['section3-faq-answer-img']}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <div className={styles['footer-snap']}>
        <AixueFooter />
      </div>
    </div>
  );
}
